var _feFlood, _feComposite, _feGaussianBlur, _feOffset, _feComposite2, _feColorMatrix, _feFlood2, _feComposite3, _feGaussianBlur2, _feOffset2, _feComposite4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFizzLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 16.667
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: -24.5,
    result: "offset"
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "fbSourceGraphic"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite1"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 16.7
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 25.3,
    result: "offset"
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "offset",
    result: "composite2"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.777 1026.192s-.172-2.985-.164-4.047c.01-1.524.22-3.71.22-3.71l7.814-1.255s.663-2.276 1.12-3.367c.444-1.063 1.568-3.079 1.568-3.079l-4.465-6.638s1.646-1.998 2.53-2.89c.942-.95 2.947-2.614 2.947-2.614l6.512 4.722s1.838-1.006 2.745-1.383c1.046-.435 3.113-1.054 3.113-1.054l1.487-8.037s2.251-.266 3.681-.254c1.18.013 4.141.292 4.141.292l1.265 7.944s2.056.618 3.018 1.013c.909.373 2.594 1.292 2.594 1.292l6.695-4.675s2.138 1.723 3.1 2.677c.925.916 2.562 2.935 2.562 2.935l-4.628 6.445s1.1 1.962 1.555 2.99c.406.914 1.03 2.838 1.03 2.838l7.908 1.442s.398 2.63.45 3.945c.054 1.314-.132 3.944-.132 3.944l-7.757 1.237s-.522 2.286-.908 3.39c-.382 1.089-1.396 3.186-1.396 3.186l4.59 6.783s-1.262 1.682-2.171 2.656c-.815.872-3 2.88-3 2.88l-6.315-4.618s-1.82 1.15-2.872 1.637c-1.195.553-3.864 1.436-3.864 1.436l-1.414 8.057s-2.335.217-3.551.243c-1.29.028-3.963-.093-3.963-.093l-1.2-7.945s-2.34-.579-3.538-1.054c-1.127-.447-3.435-1.713-3.435-1.713l-6.585 4.598s-1.99-1.62-2.879-2.51c-.888-.89-2.454-2.83-2.454-2.83l4.642-6.478s-1.2-2.221-1.668-3.379-1.139-3.564-1.139-3.564z",
    style: {
      fill: "#151515",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".02623214px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(0 -992.362)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "translate(0 -992.362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -712.505,
    cy: 755.169,
    rx: 5.137,
    ry: 23.688,
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.65594494,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.71741 -.69665 .71741 .69665 0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 733.908,
    cy: 690.428,
    rx: 5.137,
    ry: 23.688,
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.65594494,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.69665 .71741 -.69665 .71741 0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.989,
    cy: 1008.28,
    rx: 1.349,
    ry: 1.312,
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 25,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.109,
    cy: 1031.551,
    rx: 1.349,
    ry: 1.312,
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 25,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.668 1017.017h34.955v10.755H12.668z",
    style: {
      fill: "#151515",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 25,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(0 -992.362)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "562.5px",
      lineHeight: "125%",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      filter: "url(#a)"
    },
    transform: "translate(24.286 15.504)scale(.02623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-409.177 341.213h285.37v79.925h-179.627v76.355h168.915v79.926h-168.915v173.858h-105.743zM-35.935 341.213H69.808v410.064H-35.935z",
    style: {
      textAlign: "center",
      letterSpacing: "-11.27999973px",
      textAnchor: "middle"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.573 341.213H487.27v63.995l-220 266.144h226.318v79.925h-357.33v-63.995l220-266.144H142.573zM550.166 341.213h344.696v63.995L674.861 671.352h226.318v79.925H543.85v-63.995L763.85 421.138H550.166z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "562.5px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "&quot",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#fff",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFizzLogo);
export default __webpack_public_path__ + "static/media/fizz-logo.5fc2dfe9ab86670122a32c96ec68f2b7.svg";
export { ForwardRef as ReactComponent };